import { Form, Input } from 'antd';

export default function AppInput({
  name,
  label,
  rules = [],
  useFormItem = true,
  ...rest
}) {
  if (!useFormItem) {
    return <Input {...rest} />;
  }

  return (
    <Form.Item name={name} label={label} rules={rules}>
      <Input {...rest} />
    </Form.Item>
  );
}
